import React, { useState, useEffect } from 'react';
import {
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import FolderIcon from '@material-ui/icons/Folder';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import SpaIcon from '@material-ui/icons/Spa';
import DetailButton from '../DetailButton/DetailButton';
import RBISearchButton from '../RBISearchButton/RBISearchButton';
import RBIAvailabilityButton from '../RBIAvailabilityButton/RBIAvailabilityButton';
import styles from './styles';
import { useTranslation } from 'react-i18next';
import useMediaQuery from '@material-ui/core/useMediaQuery';

/**
 * Form for category and product sheets.
 * @param commodityGroups
 * @param commodities
 * @param searchObject
 * @param handleChangeAutocomplete
 * @param handleApplyButton
 * @param fetchCommodities
 * @param showDetailCommodity
 */
const CommoditiesTable = ({
  commodityGroups,
  commodities,
  searchObject,
  handleChangeAutocomplete,
  handleApplyButton,
  fetchCommodities,
  showDetailCommodity,
}) => {
  const classes = styles();
  const [groupsOpen, setGroupsOpen] = useState({});
  const [openCommodities, setOpenCommodities] = useState(commodities);
  /**
   * Gets the commodities found in each group.
   * @param id
   */

  useEffect(() => {
    setGroupsOpen({});
  }, [commodityGroups]);

  const onOpenClick = id => () => {
    setGroupsOpen({ ...groupsOpen, [id]: !groupsOpen[id] });
    if (!groupsOpen[id] && !commodities[id]?.length) {
      fetchCommodities(id);
    }
  };
  const { t } = useTranslation();
  const matches = useMediaQuery('(min-width:1200px)');

  useEffect(() => {
    setOpenCommodities({ ...openCommodities, ...commodities });
  }, [commodities]);

  return (
    <TableContainer>
      <Table
        stickyHeader
        aria-label="sticky table"
        size="small"
        padding="none"
        style={{ minHeight: '70vh' }}
      >
        <TableHead>
          <TableRow>
            <TableCell className={classes.divFilters}>
              <div style={{ marginTop: 10 }}>
                <RBIAvailabilityButton
                  textButton={t('app.common.filter')}
                  onApply={handleApplyButton}
                />
              </div>
              <RBISearchButton
                id={'commodity'}
                valueOption={searchObject['commodity']}
                labelText={t('commodities.commodities')}
                onChange={handleChangeAutocomplete}
                handleApplyButton={handleApplyButton}
                textButton={t('app.common.filter')}
                noOptions={true}
              />
              <RBISearchButton
                id={'commoditySpecNumber'}
                valueOption={searchObject['commoditySpecNumber']}
                labelText={t('commodities.SPEQNumber')}
                onChange={handleChangeAutocomplete}
                handleApplyButton={handleApplyButton}
                textButton={t('app.common.filter')}
                noOptions={true}
              />
            </TableCell>
          </TableRow>
        </TableHead>
        {
          <TableBody className={classes.tableFlex}>
            {commodityGroups.length && groupsOpen ? (
              commodityGroups.map((group, indexPlatform) => {
                const row = [
                  <TableRow
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    key={`row_${group.commoditySubTypeId}`}
                  >
                    <TableCell className={classes.cells}>
                      <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={onOpenClick(group.commoditySubTypeId)}
                      >
                        {!groupsOpen[group.commoditySubTypeId] ? (
                          <ChevronRightIcon />
                        ) : (
                          <KeyboardArrowDownIcon />
                        )}
                      </IconButton>
                      <FolderIcon className={classes.icons} />
                      {`${group.commoditySubType}(${group.commoditiesTotal})`}
                    </TableCell>
                  </TableRow>,
                ];
                if (
                  openCommodities[group.commoditySubTypeId] &&
                  groupsOpen[group.commoditySubTypeId]
                ) {
                  row.push(
                    openCommodities[group.commoditySubTypeId].map(commodity => [
                      <TableRow key={`row_${commodity.commoditySpecNumber}`}>
                        <TableCell
                          className={`${
                            !groupsOpen[group.commoditySubTypeId]
                              ? classes.borderBottom
                              : classes.cells
                          }`}
                        >
                          <Collapse
                            in={groupsOpen[group.commoditySubTypeId]}
                            timeout="auto"
                            className={classes.divGroups}
                          >
                            {matches ? (
                              <div className={classes.divItems}>
                                <div className={classes.divCellText}>
                                  <SpaIcon className={classes.icons} />{' '}
                                  {commodity.commodity}
                                </div>
                                <div className={classes.divCellIconDetails}>
                                  <DetailButton
                                    callbackFunction={showDetailCommodity(
                                      group.commoditySubTypeId,
                                      commodity.commoditySpecNumber,
                                    )}
                                  />
                                </div>
                              </div>
                            ) : (
                              <div className={classes.divItemsSmallScreen}>
                                <div className={classes.divCellTextSmallScreen}>
                                  <SpaIcon className={classes.icons} />{' '}
                                  {commodity.commodity}
                                </div>
                                <div
                                  className={
                                    classes.divCellIconDetailsSmallScreen
                                  }
                                >
                                  <DetailButton
                                    callbackFunction={showDetailCommodity(
                                      group.commoditySubTypeId,
                                      commodity.commoditySpecNumber,
                                    )}
                                  />
                                </div>
                              </div>
                            )}
                          </Collapse>
                        </TableCell>
                      </TableRow>,
                    ]),
                  );
                }
                return row;
              })
            ) : (
              <TableRow>
                <TableCell className={`${classes.cells} ${classes.noResults}`}>
                  <Typography>{t('commodities.noSearchResults')}</Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        }
      </Table>
    </TableContainer>
  );
};

export default CommoditiesTable;
